var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("SHIPMENT REAL")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between mb-3"
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('b-form', {
          staticClass: "d-flex",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.onFilter.apply(null, arguments);
            }
          }
        }, [_c('b-form-input', {
          staticClass: "mr-2",
          staticStyle: {
            "width": "220px"
          },
          attrs: {
            "placeholder": "search project..."
          },
          model: {
            value: _vm.params.keyword,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "keyword", $$v);
            },
            expression: "params.keyword"
          }
        })], 1), _c('b-button', {
          staticClass: "d-flex align-items-center",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.toggleModalFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _c('p', {
          staticClass: "text-truncate m-0"
        }, [_vm._v("Filter Data")])]), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.top",
            value: 'Refresh Data',
            expression: "'Refresh Data'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "d-flex align-items-center ml-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.onFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-sync-alt"
        })])], 1), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-dropdown', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.top",
            value: 'Export Data',
            expression: "'Export Data'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "link iq-bg-primary",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('span', {
                staticClass: "dropdown-toggle p-0",
                attrs: {
                  "id": "dropdownMenuButton5",
                  "data-toggle": "dropdown"
                }
              }, [_c('i', {
                staticClass: "fa fa-download mr-1"
              }), _vm._v(" Export ")])];
            },
            proxy: true
          }])
        }, [_c('b-dropdown-item', {
          attrs: {
            "href": "#",
            "variant": "dark"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.show('report-ports');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-excel mr-2"
        }), _vm._v(" Export Report All Ports ")])], 1), _c('b-button', {
          staticClass: "float-right mr-1",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.slideRunningShipment = true;
            }
          }
        }, [_vm._v(" View Running Operation Data ")])], 1)]), _c('b-modal', {
          attrs: {
            "centered": "",
            "title": "Filter Data",
            "ok-title": "Filter"
          },
          on: {
            "ok": _vm.onFilter
          },
          model: {
            value: _vm.modal.filter,
            callback: function callback($$v) {
              _vm.$set(_vm.modal, "filter", $$v);
            },
            expression: "modal.filter"
          }
        }, [_c('b-row', {}, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Period",
            "label-for": "Period",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('date-picker', {
          style: {
            width: '100%'
          },
          attrs: {
            "type": "date",
            "range": "",
            "placeholder": "Select date range"
          },
          model: {
            value: _vm.dateRange,
            callback: function callback($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Cargo Type",
            "label-for": "cargo",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsCargoType
          },
          model: {
            value: _vm.params.cargo_type_id,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "cargo_type_id", $$v);
            },
            expression: "params.cargo_type_id"
          }
        }, [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v(" All ")])], 1)], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Stage Status",
            "label-for": "stage_id",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('b-form-select', {
          staticClass: "mb-2",
          attrs: {
            "plain": "",
            "options": _vm.optionsStage
          },
          model: {
            value: _vm.params.stage_id,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "stage_id", $$v);
            },
            expression: "params.stage_id"
          }
        }, [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v(" All ")])], 1)], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "mb-3",
          attrs: {
            "label": "Ownership",
            "label-for": "fleet_ownership",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('b-form-select', {
          staticClass: "mb-2",
          attrs: {
            "plain": ""
          },
          model: {
            value: _vm.params.fleet_ownership,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "fleet_ownership", $$v);
            },
            expression: "params.fleet_ownership"
          }
        }, [_c('b-form-select-option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("All")]), _c('b-form-select-option', {
          attrs: {
            "value": "own-ship"
          }
        }, [_vm._v(" Own Ship ")]), _c('b-form-select-option', {
          attrs: {
            "value": "chartered"
          }
        }, [_vm._v(" Chartered ")])], 1)], 1)], 1), _vm.params.fleet_ownership ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Vehicle",
            "label-for": "vehicle_id",
            "label-cols-sm": "4",
            "label-cols-lg": "3"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "name": "vehicle_id",
            "options": _vm.optionsFleets,
            "reduce": function reduce(optionsFleets) {
              return optionsFleets.value;
            },
            "placeholder": "Select Fleet"
          },
          model: {
            value: _vm.params.vehicle_id,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "vehicle_id", $$v);
            },
            expression: "params.vehicle_id"
          }
        })], 1)], 1) : _vm._e()], 1)], 1), _c('b-row', [!_vm.loading ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex overflow-auto",
          staticStyle: {
            "max-height": "500px"
          }
        }, [_c('table', {
          staticClass: "table table-xs"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', {
          staticClass: "sticky-header"
        }, [_c('th', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "200x"
          }
        }, [_vm._v("Shipper")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Cargo TYPE")]), _c('th', {
          staticClass: "bg-primary-custom text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(" Shipment Plan ")]), _c('th', {
          staticClass: "bg-primary-custom text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(" Volume Plan ")]), _c('th', {
          staticClass: "bg-warning-custom text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(" Shipment Real ")]), _c('th', {
          staticClass: "bg-warning-custom text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(" Volume Real ")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Stage")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Action")])])]), _vm.list.data.length > 0 ? _c('tbody', _vm._l(_vm.list.data, function (state, index) {
          var _state$company$compan, _state$company, _state$cargo_type, _state$volume, _state$cargo_type2, _state$cargo_type2$un, _state$cargo_type2$un2, _state$cargo_type2$un3, _state$volume_real, _state$cargo_type3, _state$cargo_type3$un, _state$cargo_type3$un2, _state$cargo_type3$un3, _state$project_stage;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-truncate text-center"
          }, [_c('div', {
            staticClass: "d-flex align-items-center",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                var _state$customer;
                return _vm.openNewWindow(state === null || state === void 0 ? void 0 : (_state$customer = state.customer) === null || _state$customer === void 0 ? void 0 : _state$customer.id);
              }
            }
          }, [_c('h6', {
            staticClass: "ml-2 text-primary"
          }, [_c('strong', [_vm._v(" " + _vm._s((_state$company$compan = state === null || state === void 0 ? void 0 : (_state$company = state.company) === null || _state$company === void 0 ? void 0 : _state$company.company) !== null && _state$company$compan !== void 0 ? _state$company$compan : '-') + " ")])])])]), _c('td', {
            staticClass: "text-truncate text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.openSlideFormAddPlan('PREVIEW', state === null || state === void 0 ? void 0 : state.id);
              }
            }
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$cargo_type = state.cargo_type) === null || _state$cargo_type === void 0 ? void 0 : _state$cargo_type.name) + " ")]), _c('td', {
            staticClass: "text-truncate",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.openSlideFormAddPlan('PREVIEW', state === null || state === void 0 ? void 0 : state.id);
              }
            }
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.shipment) + " SHIPMENT ")]), _c('td', {
            staticClass: "text-truncate",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.openSlideFormAddPlan('PREVIEW', state === null || state === void 0 ? void 0 : state.id);
              }
            }
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.volume ? state === null || state === void 0 ? void 0 : (_state$volume = state.volume) === null || _state$volume === void 0 ? void 0 : _state$volume.toLocaleString() : '0') + " " + _vm._s(state === null || state === void 0 ? void 0 : (_state$cargo_type2 = state.cargo_type) === null || _state$cargo_type2 === void 0 ? void 0 : (_state$cargo_type2$un = _state$cargo_type2.unit) === null || _state$cargo_type2$un === void 0 ? void 0 : (_state$cargo_type2$un2 = _state$cargo_type2$un.child) === null || _state$cargo_type2$un2 === void 0 ? void 0 : (_state$cargo_type2$un3 = _state$cargo_type2$un2.find(function (el) {
            return el.name === state.unit;
          })) === null || _state$cargo_type2$un3 === void 0 ? void 0 : _state$cargo_type2$un3.alias) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.shipment_real) + " SHIPMENT ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.volume_real ? state === null || state === void 0 ? void 0 : (_state$volume_real = state.volume_real) === null || _state$volume_real === void 0 ? void 0 : _state$volume_real.toLocaleString() : '0') + " " + _vm._s(state === null || state === void 0 ? void 0 : (_state$cargo_type3 = state.cargo_type) === null || _state$cargo_type3 === void 0 ? void 0 : (_state$cargo_type3$un = _state$cargo_type3.unit) === null || _state$cargo_type3$un === void 0 ? void 0 : (_state$cargo_type3$un2 = _state$cargo_type3$un.child) === null || _state$cargo_type3$un2 === void 0 ? void 0 : (_state$cargo_type3$un3 = _state$cargo_type3$un2.find(function (el) {
            return el.name === state.unit;
          })) === null || _state$cargo_type3$un3 === void 0 ? void 0 : _state$cargo_type3$un3.alias) + " ")]), _c('td', {
            staticClass: "bg-white text-black text-center"
          }, [_c('b-button', {
            staticClass: "text-nowrap",
            attrs: {
              "id": "stage-popover-".concat(index, "-").concat(state === null || state === void 0 ? void 0 : state.id),
              "variant": "primary",
              "size": "sm"
            }
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$project_stage = state.project_stage) === null || _state$project_stage === void 0 ? void 0 : _state$project_stage.title) + " "), _c('i', {
            staticClass: "fas fa-chevron-down ml-2"
          })]), _c('b-popover', {
            attrs: {
              "target": "stage-popover-".concat(index, "-").concat(state === null || state === void 0 ? void 0 : state.id),
              "triggers": "focus",
              "placement": "left",
              "custom-class": "p-0 border-0 shadow-sm"
            }
          }, [_c('div', {
            staticClass: "list-group list-group-flush text-left"
          }, _vm._l(_vm.listProjectStage, function (obj, objIndex) {
            return _c('button', {
              key: objIndex,
              staticClass: "list-group-item list-group-item-action",
              class: {
                active: (state === null || state === void 0 ? void 0 : state.detail_project_stage_id) === obj.id
              },
              on: {
                "click": function click($event) {
                  return _vm.onChangeStatusStage(index, state === null || state === void 0 ? void 0 : state.id, obj.id);
                }
              }
            }, [_vm._v(" " + _vm._s(obj === null || obj === void 0 ? void 0 : obj.title) + " ")]);
          }), 0)])], 1), _c('td', {
            staticClass: "bg-white text-black text-center"
          }, [_c('b-button', {
            attrs: {
              "id": "action-popover-".concat(index, "-").concat(state === null || state === void 0 ? void 0 : state.id),
              "variant": "outline-primary",
              "size": "sm"
            }
          }, [_vm._v(" Action ")]), _c('b-popover', {
            attrs: {
              "target": "action-popover-".concat(index, "-").concat(state === null || state === void 0 ? void 0 : state.id),
              "triggers": "focus",
              "placement": "left",
              "custom-class": "p-0 border-0 shadow-sm"
            }
          }, [_c('div', {
            staticClass: "list-group list-group-flush text-left"
          }, [_c('button', {
            staticClass: "list-group-item list-group-item-action",
            on: {
              "click": function click($event) {
                return _vm.openSlideFormAddPlan('PREVIEW', state === null || state === void 0 ? void 0 : state.id);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-eye mr-2"
          }), _vm._v(" Detail ")]), _c('button', {
            staticClass: "list-group-item list-group-item-action",
            on: {
              "click": function click($event) {
                return _vm.openSlideFormRealShipment('ADD', state === null || state === void 0 ? void 0 : state.id);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-plus mr-2"
          }), _vm._v(" Add Real Shipment ")])])])], 1)]);
        }), 0) : _c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-center align-middle",
          attrs: {
            "colspan": "9"
          }
        }, [_c('h6', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("No Data Found.")])])])])])])]), _vm.list.data.length > 0 ? _c('div', {
          staticClass: "mt-3"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.list.meta.totalItem,
            "per-page": _vm.list.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getListRunningShipmentTable
          },
          model: {
            value: _vm.page,
            callback: function callback($$v) {
              _vm.page = $$v;
            },
            expression: "page"
          }
        })], 1) : _vm._e()]) : _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "alert alert-info"
        }, [_vm._v("Loading...")])])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "add_rakor",
      "title": ['PREVIEW', 'EDIT'].includes(_vm.action) ? 'DETAIL PLAN' : "ADD PLAN",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hide = _ref.hide;
        return [_vm.slideAddRakor ? _c('FormAddPlanNew', {
          attrs: {
            "optionsCompanies": _vm.optionsCompanies,
            "optionsFleets": _vm.optionsFleets,
            "editId": _vm.editId,
            "isDetail": _vm.action === 'PREVIEW'
          },
          on: {
            "refresh-data": _vm.getListRunningShipmentTable
          }
        }) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.slideAddRakor,
      callback: function callback($$v) {
        _vm.slideAddRakor = $$v;
      },
      expression: "slideAddRakor"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideFormRealShipment",
      "title": "Create Real Shipment",
      "width": "90%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var hide = _ref2.hide;
        return [_c('SlideFormRealShipment', {
          attrs: {
            "closeSlideFormRealShipment": _vm.closeSlideFormRealShipment,
            "refreshData": function refreshData() {},
            "optionsFleets": _vm.optionsFleets,
            "projectId": _vm.idRealShipment,
            "action": _vm.actionRealShipment
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideFormRealShipment,
      callback: function callback($$v) {
        _vm.slideFormRealShipment = $$v;
      },
      expression: "slideFormRealShipment"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideRunningShipment",
      "title": "Operational Data Running Shipment",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    model: {
      value: _vm.slideRunningShipment,
      callback: function callback($$v) {
        _vm.slideRunningShipment = $$v;
      },
      expression: "slideRunningShipment"
    }
  }, [_c('SlideRunningShipment')], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "report-ports",
      "size": "md",
      "title": "Export Report All Ports",
      "cancel-title": "Close",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var hide = _ref3.hide;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "*List Ports",
            "label-for": "vehicle_type"
          }
        }, [_c('v-multiselect', {
          attrs: {
            "options": _vm.positionList,
            "placeholder": "Select...",
            "track-by": "value",
            "label": "text",
            "multiple": true
          },
          model: {
            value: _vm.exportForm.portIds,
            callback: function callback($$v) {
              _vm.$set(_vm.exportForm, "portIds", $$v);
            },
            expression: "exportForm.portIds"
          }
        }, [_c('span', {
          attrs: {
            "slot": "noResult"
          },
          slot: "noResult"
        }, [_vm._v("Oops! No elements found.")])])], 1), _c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "*Start Date",
            "label-for": "startDate"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker w-100",
          attrs: {
            "value-type": "DD-MM-YYYY",
            "type": "date",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY"
          },
          model: {
            value: _vm.exportForm.startDate,
            callback: function callback($$v) {
              _vm.$set(_vm.exportForm, "startDate", $$v);
            },
            expression: "exportForm.startDate"
          }
        })], 1), _c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "*End Date",
            "label-for": "startDate"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker w-100",
          attrs: {
            "value-type": "DD-MM-YYYY",
            "type": "date",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY"
          },
          model: {
            value: _vm.exportForm.endDate,
            callback: function callback($$v) {
              _vm.$set(_vm.exportForm, "endDate", $$v);
            },
            expression: "exportForm.endDate"
          }
        })], 1), _c('div', {
          staticClass: "d-flex w-100 align-items-center justify-content-end"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "secondary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('report-ports');
            }
          }
        }, [_vm._v(" Cancel ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.exporting
          },
          on: {
            "click": function click($event) {
              return _vm.onExportPort();
            }
          }
        }, [_vm.exporting ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _c('div', {
          staticClass: "d-flex gap-2 align-items-center"
        }, [_c('span', [_vm._v("Export")]), _c('i', {
          staticClass: "fa fa-upload ml-2"
        })])])], 1)], 1)], 1)];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }